import React, { useEffect } from 'react';

export const useOnClickOutside = (
  ref: React.RefObject<HTMLElement>,
  handler: (event: MouseEvent) => void,
  targetElement?: React.RefObject<HTMLElement>
): void => {
  useEffect(
    () => {
      const listener = (event: MouseEvent) => {
        // Do nothing if clicking ref's element or descendent elements
        const target = event.target as HTMLElement;

        if (!ref.current || ref.current.contains(target)) {
          return;
        }

        // Do nothing if clicking targetElement or descendent elements.
        if (targetElement && targetElement.current && targetElement.current.contains(target)) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);
      // document.addEventListener('touchstart', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
        // document.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, targetElement, handler]
  );
};
